export default __webpack_public_path__ + "static/media/36I-102617_-16949_0.52b6eb46.jpg";